import { Component, ChangeDetectionStrategy, computed, input, output, signal } from '@angular/core';
import { ValidationIssue, ValidationResult } from '@formrails/workflow-designer/data-access';

/**
 * Collapsible strip that lists the workflow's validation issues. Errors
 * block save (gated upstream); warnings are advisory. Clicking an issue
 * raises `selectNode` so the canvas can focus the offending node.
 */
@Component({
  selector: 'app-workflow-validation-panel',
  standalone: true,
  imports: [],
  templateUrl: './workflow-validation-panel.component.html',
  styleUrl: './workflow-validation-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkflowValidationPanelComponent {
  readonly result = input<ValidationResult>({ errors: [], warnings: [] });

  readonly selectNode = output<string>();

  readonly expanded = signal(false);

  readonly errorCount = computed(() => this.result().errors.length);
  readonly warningCount = computed(() => this.result().warnings.length);
  readonly hasIssues = computed(() => this.errorCount() > 0 || this.warningCount() > 0);

  readonly issues = computed(() => [
    ...this.result().errors,
    ...this.result().warnings
  ]);

  toggle(): void {
    this.expanded.update(v => !v);
  }

  onSelect(issue: ValidationIssue): void {
    if (issue.nodeId) this.selectNode.emit(issue.nodeId);
  }
}
